import React from 'react';
import { Carousel } from '@/components/shared';
import { TeaserCard } from '../TeaserCard/TeaserCard';
import { TeaserCardSliderSlide, TeaserCardSliderSortOrder } from './register';

type SliderProps = {
	slides?: TeaserCardSliderSlide[];
	sortOrder?: TeaserCardSliderSortOrder;
};

const maxPreviewTextLength = 150;

const truncatePreviewText = (text?: string): string | undefined => {
	if (typeof text !== 'string') return undefined;
	if (text.length <= maxPreviewTextLength) return text;
	return text.slice(0, maxPreviewTextLength) + '...';
};

const sortSlidesByOrder = (
	slides: TeaserCardSliderSlide[],
	sortOrder: TeaserCardSliderSortOrder,
): TeaserCardSliderSlide[] => {
	if (sortOrder === 'newest') {
		return slides;
	}

	return [...slides].reverse();
};

export const TeaserCardSlider: React.FunctionComponent<SliderProps> = ({
	slides = [],
	sortOrder = 'newest',
}) => {
	const displaySlides = React.useMemo(() => sortSlidesByOrder(slides, sortOrder), [slides, sortOrder]);

	return (
		<Carousel showArrows showArrowsOnMobile disableAutoplay slidesWidth={'25%'} slideWidthMobile={'100%'}>
			{displaySlides.map((slide, i) => {
				const { image, imagePreview, altText, text, title, icon, url, ctaLabel, hideCtaLabel } = slide;
				const previewText = truncatePreviewText(text);
				const previewImage = image ?? imagePreview;

				return (
					<TeaserCard
						image={previewImage}
						altText={altText}
						text={previewText}
						title={title}
						icon={icon}
						url={url}
						ctaLabel={ctaLabel}
						hideCtaLabel={hideCtaLabel}
						ctaButtonVariant={'linkButton'}
						key={i}
					/>
				);
			})}
		</Carousel>
	);
};
